import type { JobTagWithCategory } from "@/types/db";
import { Link } from "@tanstack/react-router";

interface JobTagsGroupedProps {
  tags?: JobTagWithCategory[];
}

export default function JobTagsGrouped({ tags }: JobTagsGroupedProps) {
  if (!tags || tags.length === 0) return null;

  // Group tags by category name
  const grouped = new Map<
    string,
    { bgColor: string | null; tags: JobTagWithCategory[] }
  >();
  for (const tag of tags) {
    const categoryName = tag.category?.name ?? "Other";
    const existing = grouped.get(categoryName);
    if (existing) {
      existing.tags.push(tag);
    } else {
      grouped.set(categoryName, {
        bgColor: tag.category?.bgColor ?? null,
        tags: [tag],
      });
    }
  }

  return (
    <div className="mt-6 flex flex-col gap-3">
      {Array.from(grouped.entries()).map(
        ([categoryName, { bgColor, tags: categoryTags }]) => (
          <div
            key={categoryName}
            className="flex flex-col gap-2 sm:grid sm:grid-cols-[7rem_1fr] sm:gap-x-3 sm:gap-y-1"
          >
            <span className="pt-1 text-xs font-semibold tracking-wide text-gray-500 uppercase">
              {categoryName}
            </span>
            <div className="flex flex-wrap gap-2">
              {categoryTags.map((tag) => (
                <Link
                  key={tag.id}
                  to="/$slug"
                  params={{ slug: tag.slug }}
                  className={`${bgColor ?? "bg-gray-200"} focus-visible:ring-polaris-orange/50 inline-flex items-center rounded-full px-3 py-1 text-sm font-medium transition-colors hover:opacity-80 focus-visible:ring-2 focus-visible:outline-none`}
                >
                  {tag.name}
                </Link>
              ))}
            </div>
          </div>
        ),
      )}
    </div>
  );
}
